<template>
  <div class="section">
    <div class="container auth-container">
      <h2 class="title mb-1 is-size-4 has-text-weight-semibold">{{ $t('auth.createUserName') }}</h2>
      <p>{{ $t('auth.createUserNameToUseInApplication') }}</p>
      <p class="is-size-7 mt-1"><span class="has-text-weight-semibold">örnek:</span> senemadıgüzel, hürkuş, naptınnettin vb.</p>

      <article class="message is-danger mt-1" v-if="isErr">
        <div class="message-body">{{ errMsg }}</div>
      </article>

      <form @submit.prevent="setUsername" class="auth-form mt-1">
        <!-- email -->
        <div class="field">
          <label class="label">{{ $t('auth.username') }}</label>
          <div class="control">
            <input
              class="input is-medium"
              :class="{ 'is-danger': isErr }"
              type="text"
              :placeholder="$t('auth.enterYourUsername')"
              minlength="4"
              maxlength="12"
              @input="isValid"
              autocomplete="off"
              required
              ref="username"
            />
            <!-- todo: @input doesnt work on mobile -->
            <p class="help is-success is-size-7" :class="{ 'is-danger': isWarn }">{{warnMsg}}</p>
          </div>
          <!-- <p class="help is-danger" v-show="isNameErr">{{nameErrMsg}}</p> -->
        </div>
        <!-- ./email -->

        <div class="field mt-1">
          <div class="control">
            <button
              class="button  is-primary is-default-size is-fullwidth"
              :class="{ 'is-loading': isLoading }"
              :disabled="isDisabled"
            >{{ $t('auth.saveUsername') }}</button>
          </div>
        </div>
      </form>

      <!-- <article class="message is-sucess mt-1" v-else>
        <div class="message-body">Kullanıcı adın başarıyla kaydedildi, {{ username }}!</div>
      </article> -->

    </div>
  </div>
</template>


<style scoped>
.user-msg {
  color: green;
}
.is-error {
  color: red;
}
</style>


<script>
import { db } from "@/fireinit";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      username: "",
      isErr: false,
      errMsg: "",
      isWarn: false,
      warnMsg: "",
      invalidUsername: false,
      isLoading: false,
      minLen: 4,
      maxLen: 12,
      isUnVerified: false,
      usernames: [],
      isDisabled: false
    };
  },
  methods: {
    ...mapMutations({
      hideBottomNavbar: "ui/SET_HIDE_BOTTOM_NAVBAR",
      
    }),
    resetErrs() {
      this.isErr = false;
      this.isDisabled = false
      this.errMsg = "";
    },
    isValid(e) {
      // console.log('target value', e.target.value)
      this.isDisabled = false
      // force toconvert to lowercase
      this.$refs.username.value = this.username = e.target.value.toLocaleLowerCase()

      if (this.username.length < 4) {
        this.warnMsg = "";
        return;
      }
      if (!/^[a-z]+$/.test(this.username)) {
        this.isWarn = true;
        this.isDisabled = true
        this.warnMsg = `Yalnızca harf kullanabilirsin`;
      } else if (this.usernames.indexOf(this.username.trim()) > -1) {
        this.isWarn = true;
        this.isDisabled = true
        this.warnMsg = `@${this.username} başkası tarafından alınmış`;
      } else {
        this.isWarn = false;
        this.isDisabled = false
        this.warnMsg = `@${this.username} kullanılabilir`;
      }
    },
    async setUsername() {
      this.isLoading = true;
      try {
        await this.$store.dispatch("user/chooseUsername", this.username.trim());
        this.isErr = false;
        this.$router.push("/");
      } catch (error) {
        console.log(error);
        if (error.code === "failed-precondition") {
          this.isErr = true;
          this.errMsg = error.message;
        } else {
          console.log('error on username setting', error)
          this.isErr = true;
          this.errMsg =
            "İşleminiz gerçekleştirilemedi. Lütfen tekrar giriş yapmayı deneyin.";
        }
      }
      this.isLoading = false;
    },
    async getUsernames() {
      try {
        const qSnap = await db.collection("users").get();
        qSnap.forEach(doc => {
          this.usernames.push(doc.data().username);
        });
      } catch (error) {
        this.isErr = true;
        this.errMsg = error.message;
      }
    }
  },
  mounted() {
    this.getUsernames();
    this.$store.commit('ui/SET_HIDE_BOTTOM_NAVBAR', true)
  },
  beforeDestroy() {
    this.$store.commit('ui/SET_HIDE_BOTTOM_NAVBAR', false)
  }
  
};
</script>
